import React from "react";
import { FaEnvelope } from "react-icons/fa";

const CounsellingVCard = ({ data }) => {
  return (
    <div
      className="bg-white rounded-lg shadow-lg p-4 flex flex-col items-start justify-center w-[300px] h-[100px]"
    >
      <h2 className="text-xl font-semibold text-primary-color mb-1">{data.name}</h2>
      <p className="text-gray-600 text-sm mb-1">{data.designation}</p>
      <div className="flex items-center justify-between w-full mt-2">
        <p className="text-primary-color text-xs">
          {data.tele}
        </p>
        <a
          href={`mailto:${data.email}`}
          className="text-primary-color hover:text-purple-700"
        >
          <FaEnvelope />
        </a>
      </div>
    </div>
  );
};

export default CounsellingVCard;